export default __webpack_public_path__ + "ba1cff8abe18ed3bcebaa60c812a3a4c.png";